export default __webpack_public_path__ + "static/media/logo_standard.2e2c73bf.svg";